import { useState, useEffect } from 'react';
import PromotionalSalesPage from '../../../models/PromotionalSalesPage';

export default function usePromotionalSalesPages(packageId, schoolId, studentId, cartId) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!packageId) return;

    setIsLoading(true);

    PromotionalSalesPage
      .where({ packageId })
      .order('position')
      .extraParams({ schoolId, studentId, cartId, packageId })
      .all()
      .then((res) => setData(res.data))
      .finally(() => setIsLoading(false));
  }, [packageId]);

  return { data, isLoading };
}
